/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable arrow-body-style */
import React from 'react'
import { ImageLoader } from '@usap/uicomponents'

import styled from 'styled-components'

const StyledImageContainer = styled.div`
  width: 116px;
  height: 116px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    max-width: 144px;
    width: 144px;
    height: 144px;
  }
`

const ImageWmo = ({ data, productUrl, onClick }) => {
  return (
    <StyledImageContainer>
      <a href={productUrl} onClick={onClick}>
        <ImageLoader
          key={data.product.image.url}
          width="100%"
          height="100%"
          src={data.product.image.url}
          fit="contain"
          alt={`${data.product.sku}-${data.product.title}`}
          cloudinaryParams="h_125,w_125"
          fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
        />
      </a>
    </StyledImageContainer>
  )
}

export default ImageWmo
